import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";

class SignUpCodeButton extends Component {
  state = {}

  componentDidMount() {
    this.setState({
      signUpCode: this.props.resident.sign_up_code,
      signUpCodeCreatedAt: this.props.resident.sign_up_code_created_at
    })
  }

  handleOnClick() {
    this.props.openModal()
  }

  renderCompletedMessage() {
    const { error } = this.props
    if (error) {
      return (
        <div className="password-update-failed-button p-2">Password Update Failed: {error}</div>
      )
    } else {
      return (
        <div className="password-updated-button p-2">Password Updated</div>
      )
    }
  }

  render() {
    const { completed } = this.props
    return (
      <div className="mr-2">
        {
          completed ?
            this.renderCompletedMessage() :
            <Button
              size="sm"
              className={"change-password-button"}
              onClick={this.handleOnClick.bind(this)}
              disabled={this.state.loading}>
              Change Password
            </Button>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    completed: state.ui.passwordResetModal.completed,
    error: state.ui.passwordResetModal.error,
    resident: state.resident,
    organizationName: state.organization.name
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openModal: (resourceName) => dispatch({ type: "OPEN_RESOURCE_MODAL", payload: { resourceName: 'passwordReset' } })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpCodeButton);
